export default __webpack_public_path__ + "static/flag-europe-e4a450c6b37193bef746662c91a2ee92.jpeg";